import React from 'react';
import c from 'classnames';
import { compose } from 'redux';
import { useTranslation } from 'react-i18next';
import StandardMenu from '@wix/da-ds/pkg/Dropdown/MenuPreset/StandardMenu';
import { MediaSourceType } from '../../types';
import withCurrentMediaSource, {
  WithCurrentMediaSourceProps,
} from '../../_hocs/withCurrentMediaSource';
import withSearch, { WithSearchProps } from '../../_hocs/withSearch';
import { getTransKeyForMediaSourceType } from './_helpers';

import s from './MediaSourceMenu.scss';

export interface Props {
  mediaSourceTypes: MediaSourceType[];
}

const enhance = compose(withCurrentMediaSource, withSearch);
export const MediaSourceMenu: React.FC<
  Props & WithCurrentMediaSourceProps & WithSearchProps
> = ({
  currentMediaSource,
  mediaSourceTypes,
  changeCurrentMediaSource,
  unsetSearchInput,
  unsetSearchQuery,
}) => {
  const { t } = useTranslation();

  return (
    <StandardMenu
      id="media-source-menu"
      className={s['root']}
      lightText
      withCardWrapper={false}
      items={mediaSourceTypes.map(mediaSourceType => ({
        label: t(getTransKeyForMediaSourceType(mediaSourceType)),
        selected: mediaSourceType === currentMediaSource,
        className: c(
          s['menu-item'],
          mediaSourceType === currentMediaSource && s['selected']
        ),
        onClick: () => {
          unsetSearchInput();
          unsetSearchQuery();
          changeCurrentMediaSource(mediaSourceType);
        },
      }))}
      hideCheckIcon
    />
  );
};
MediaSourceMenu.displayName = 'MediaSourceMenu';

export default enhance(MediaSourceMenu);
